/**
 * Zeus homepage FAQ (sections/zeus-home-15-faq.liquid)
 * Delegated clicks so binding works regardless of script vs DOM order.
 */
(function () {
  function toggleItem(root, item) {
    if (!root || !item) return;
    var wasActive = item.classList.contains("active");
    root.querySelectorAll(".faq-item.active").forEach(function (el) {
      el.classList.remove("active");
    });
    if (!wasActive) item.classList.add("active");
  }

  document.addEventListener(
    "click",
    function (event) {
      var btn =
        event.target.closest &&
        event.target.closest(".zeus-home-15 .faq-question, .zeus-product-faq .faq-question");
      if (!btn) return;
      var root = btn.closest(".zeus-home-15, .zeus-product-faq");
      var item = btn.closest(".faq-item");
      if (!root || !item || !root.contains(item)) return;
      event.preventDefault();
      toggleItem(root, item);
    },
    false
  );

  document.addEventListener("shopify:section:load", function (event) {
    var root =
      (event.target &&
        event.target.querySelector &&
        (event.target.querySelector(".zeus-home-15") ||
          event.target.querySelector(".zeus-product-faq"))) ||
      null;
    if (!root) return;
    root.querySelectorAll(".faq-item.active").forEach(function (el) {
      el.classList.remove("active");
    });
  });
})();
